// // // // // import React, { useState, useEffect } from "react";
// // // // // import { useDispatch, useSelector } from "react-redux";
// // // // // import { useHistory } from "react-router-dom";
// // // // // import { useSnackbar } from "react-simple-snackbar";
// // // // // import { makeStyles } from "@material-ui/core/styles";
// // // // // import {
// // // // //   Container,
// // // // //   Typography,
// // // // //   Button,
// // // // //   Table,
// // // // //   TableBody,
// // // // //   TableCell,
// // // // //   TableHead,
// // // // //   TableRow,
// // // // //   Paper,
// // // // //   TableContainer,
// // // // //   Box,
// // // // //   TextField,
// // // // //   Dialog,
// // // // //   DialogTitle,
// // // // //   DialogContent,
// // // // //   DialogActions,
// // // // // } from "@material-ui/core";
// // // // // import ArrowBackIcon from "@material-ui/icons/ArrowBack";
// // // // // import EditIcon from "@material-ui/icons/Edit";
// // // // // import DeleteIcon from "@material-ui/icons/Delete";
// // // // // import { deleteFuturePrice, fetchFuturePriceList, updateFuturePrice } from "../../actions/itemActions";

// // // // // const useStyles = makeStyles((theme) => ({
// // // // //   container: {
// // // // //     padding: theme.spacing(3),
// // // // //     maxWidth: 1200,
// // // // //   },
// // // // //   header: {
// // // // //     display: "flex",
// // // // //     alignItems: "center",
// // // // //     justifyContent: "space-between",
// // // // //     marginBottom: theme.spacing(3),
// // // // //   },
// // // // //   tableContainer: {
// // // // //     marginTop: theme.spacing(2),
// // // // //     maxHeight: "60vh",
// // // // //     borderRadius: theme.shape.borderRadius,
// // // // //     boxShadow: theme.shadows[2],
// // // // //   },
// // // // //   backButton: {
// // // // //     borderRadius: 20,
// // // // //   },
// // // // //   button: {
// // // // //     margin: theme.spacing(1),
// // // // //     borderRadius: 20,
// // // // //     padding: theme.spacing(1, 3),
// // // // //     textTransform: "none",
// // // // //   },
// // // // //   textField: {
// // // // //     "& .MuiOutlinedInput-root": {
// // // // //       "& fieldset": {
// // // // //         borderColor: "#ddd",
// // // // //       },
// // // // //       "&:hover fieldset": {
// // // // //         borderColor: "#ef7f1a",
// // // // //       },
// // // // //       "&.Mui-focused fieldset": {
// // // // //         borderColor: "#ef7f1a",
// // // // //       },
// // // // //     },
// // // // //   },
// // // // //   disabledRow: {
// // // // //     backgroundColor: theme.palette.grey[200],
// // // // //     opacity: 0.6,
// // // // //   },
// // // // //   dialogTitle: {
// // // // //     backgroundColor: "#ef7f1a",
// // // // //     color: "white",
// // // // //   },
// // // // //   dialogContent: {
// // // // //     padding: theme.spacing(2),
// // // // //   },
// // // // // }));

// // // // // const FuturePriceListView = () => {
// // // // //   const classes = useStyles();
// // // // //   const dispatch = useDispatch();
// // // // //   const history = useHistory();
// // // // //   const [openSnackbar] = useSnackbar();
// // // // //   const { items, futurePrices, isLoading } = useSelector((state) => state.items);

// // // // //   // State for edit dialog
// // // // //   const [editDialogOpen, setEditDialogOpen] = useState(false);
// // // // //   const [editPrice, setEditPrice] = useState({
// // // // //     _id: "",
// // // // //     itemId: "",
// // // // //     salePrice: "",
// // // // //     effectiveDate: "",
// // // // //   });
// // // // //   const [editErrors, setEditErrors] = useState({ salePrice: "", effectiveDate: "" });

// // // // //   useEffect(() => {
// // // // //     dispatch(fetchFuturePriceList());
// // // // //   }, [dispatch]);

// // // // //   const handleEditOpen = (price) => {
// // // // //     setEditPrice({
// // // // //       _id: price._id,
// // // // //       itemId: price.itemId,
// // // // //       salePrice: price.salePrice.toString(),
// // // // //       effectiveDate: price.effectiveDate,
// // // // //     });
// // // // //     setEditErrors({ salePrice: "", effectiveDate: "" });
// // // // //     setEditDialogOpen(true);
// // // // //   };

// // // // //   const handleEditClose = () => {
// // // // //     setEditDialogOpen(false);
// // // // //     setEditPrice({ _id: "", itemId: "", salePrice: "", effectiveDate: "" });
// // // // //   };

// // // // //   const validateEditForm = () => {
// // // // //     let isValid = true;
// // // // //     const errors = { salePrice: "", effectiveDate: "" };

// // // // //     if (!editPrice.salePrice || isNaN(Number(editPrice.salePrice))) {
// // // // //       errors.salePrice = "Price must be a valid number";
// // // // //       isValid = false;
// // // // //     }
// // // // //     if (editPrice.salePrice && Number(editPrice.salePrice) < 0) {
// // // // //       errors.salePrice = "Price cannot be negative";
// // // // //       isValid = false;
// // // // //     }
// // // // //     if (!editPrice.effectiveDate) {
// // // // //       errors.effectiveDate = "Please select an effective date";
// // // // //       isValid = false;
// // // // //     } else {
// // // // //       const selectedDate = new Date(editPrice.effectiveDate);
// // // // //       const today = new Date();
// // // // //       today.setHours(0, 0, 0, 0);
// // // // //       if (selectedDate <= today) {
// // // // //         errors.effectiveDate = "Effective date must be in the future";
// // // // //         isValid = false;
// // // // //       }
// // // // //     }

// // // // //     setEditErrors(errors);
// // // // //     return isValid;
// // // // //   };

// // // // //   const handleEditSubmit = async () => {
// // // // //     if (!validateEditForm()) {
// // // // //       openSnackbar("Please correct the errors before submitting");
// // // // //       return;
// // // // //     }

// // // // //     try {
// // // // //       await dispatch(
// // // // //         updateFuturePrice(
// // // // //           editPrice._id,
// // // // //           {
// // // // //             itemId: editPrice.itemId,
// // // // //             salePrice: Number(editPrice.salePrice),
// // // // //             effectiveDate: editPrice.effectiveDate,
// // // // //           },
// // // // //           openSnackbar
// // // // //         )
// // // // //       );
// // // // //       handleEditClose();
// // // // //     } catch (error) {
// // // // //       openSnackbar("Failed to update future price");
// // // // //     }
// // // // //   };

// // // // //   const handleDelete = async (id) => {
// // // // //     if (window.confirm("Are you sure you want to delete this scheduled price?")) {
// // // // //       try {
// // // // //         await dispatch(deleteFuturePrice(id, openSnackbar));
// // // // //       } catch (error) {
// // // // //         openSnackbar("Failed to delete future price");
// // // // //       }
// // // // //     }
// // // // //   };

// // // // //   const handleBack = () => {
// // // // //     history.push("/ItemsList");
// // // // //   };

// // // // //   return (
// // // // //     <Container className={classes.container}>
// // // // //       <Box className={classes.header}>
// // // // //         <Button
// // // // //           variant="outlined"
// // // // //           color="primary"
// // // // //           startIcon={<ArrowBackIcon />}
// // // // //           onClick={handleBack}
// // // // //           className={classes.backButton}
// // // // //         >
// // // // //           Back to ItemList
// // // // //         </Button>
// // // // //         <Typography variant="h4">Future Price List</Typography>
// // // // //         <div style={{ width: 100 }} />
// // // // //       </Box>

// // // // //       {isLoading ? (
// // // // //         <Typography variant="h6" align="center">
// // // // //           Loading...
// // // // //         </Typography>
// // // // //       ) : futurePrices.length === 0 ? (
// // // // //         <Typography variant="h6" color="textSecondary" align="center">
// // // // //           No future prices scheduled.
// // // // //         </Typography>
// // // // //       ) : (
// // // // //         <TableContainer component={Paper} className={classes.tableContainer}>
// // // // //           <Table stickyHeader size="small">
// // // // //             <TableHead>
// // // // //               <TableRow>
// // // // //                 <TableCell>S.No</TableCell>
// // // // //                 <TableCell>Item Name</TableCell>
// // // // //                 <TableCell>Sale Price</TableCell>
// // // // //                 <TableCell>Effective Date</TableCell>
// // // // //                 <TableCell>Created At</TableCell>
// // // // //                 <TableCell>Status</TableCell>
// // // // //                 <TableCell>Actions</TableCell>
// // // // //               </TableRow>
// // // // //             </TableHead>
// // // // //             <TableBody>
// // // // //               {futurePrices.map((price, index) => {
// // // // //                 const item = items.find((i) => i._id === price.itemId);
// // // // //                 const isApplied = price.isApplied || new Date(price.effectiveDate) <= new Date();
// // // // //                 return (
// // // // //                   <TableRow
// // // // //                     key={price._id}
// // // // //                     className={isApplied ? classes.disabledRow : ""}
// // // // //                   >
// // // // //                     <TableCell>{index + 1}</TableCell>
// // // // //                     <TableCell>{item ? item.itemName : "Unknown Item"}</TableCell>
// // // // //                     <TableCell>
// // // // //                       {price.salePrice
// // // // //                         ? `₹${price.salePrice
// // // // //                             .toString()
// // // // //                             .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
// // // // //                         : "N/A"}
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       {new Date(price.effectiveDate).toLocaleDateString()}
// // // // //                     </TableCell>
// // // // //                     <TableCell>
// // // // //                       {new Date(price.createdAt).toLocaleDateString()}
// // // // //                     </TableCell>
// // // // //                     <TableCell>{isApplied ? "Applied" : "Scheduled"}</TableCell>
// // // // //                     <TableCell>
// // // // //                       <Button
// // // // //                         variant="outlined"
// // // // //                         color="primary"
// // // // //                         size="small"
// // // // //                         startIcon={<EditIcon />}
// // // // //                         onClick={() => handleEditOpen(price)}
// // // // //                         disabled={isApplied}
// // // // //                         className={classes.button}
// // // // //                       >
// // // // //                         Edit
// // // // //                       </Button>
// // // // //                       <Button
// // // // //                         variant="outlined"
// // // // //                         color="secondary"
// // // // //                         size="small"
// // // // //                         startIcon={<DeleteIcon />}
// // // // //                         onClick={() => handleDelete(price._id)}
// // // // //                         disabled={isApplied}
// // // // //                         className={classes.button}
// // // // //                       >
// // // // //                         Delete
// // // // //                       </Button>
// // // // //                     </TableCell>
// // // // //                   </TableRow>
// // // // //                 );
// // // // //               })}
// // // // //             </TableBody>
// // // // //           </Table>
// // // // //         </TableContainer>
// // // // //       )}

// // // // //       {/* Edit Dialog */}
// // // // //       <Dialog open={editDialogOpen} onClose={handleEditClose}>
// // // // //         <DialogTitle className={classes.dialogTitle}>Edit Future Price</DialogTitle>
// // // // //         <DialogContent className={classes.dialogContent}>
// // // // //           <TextField
// // // // //             label="Sale Price"
// // // // //             type="number"
// // // // //             value={editPrice.salePrice}
// // // // //             onChange={(e) =>
// // // // //               setEditPrice({ ...editPrice, salePrice: e.target.value })
// // // // //             }
// // // // //             fullWidth
// // // // //             margin="normal"
// // // // //             variant="outlined"
// // // // //             className={classes.textField}
// // // // //             error={!!editErrors.salePrice}
// // // // //             helperText={editErrors.salePrice}
// // // // //           />
// // // // //           <TextField
// // // // //             label="Effective Date"
// // // // //             type="date"
// // // // //             value={editPrice.effectiveDate}
// // // // //             onChange={(e) =>
// // // // //               setEditPrice({ ...editPrice, effectiveDate: e.target.value })
// // // // //             }
// // // // //             fullWidth
// // // // //             margin="normal"
// // // // //             InputLabelProps={{ shrink: true }}
// // // // //             variant="outlined"
// // // // //             className={classes.textField}
// // // // //             error={!!editErrors.effectiveDate}
// // // // //             helperText={editErrors.effectiveDate}
// // // // //           />
// // // // //         </DialogContent>
// // // // //         <DialogActions>
// // // // //           <Button onClick={handleEditClose} color="primary">
// // // // //             Cancel
// // // // //           </Button>
// // // // //           <Button onClick={handleEditSubmit} color="primary" variant="contained">
// // // // //             Save
// // // // //           </Button>
// // // // //         </DialogActions>
// // // // //       </Dialog>
// // // // //     </Container>
// // // // //   );
// // // // // };

// // // // // export default FuturePriceListView;

// // // // import React, { useState, useEffect } from "react";
// // // // import { useDispatch, useSelector } from "react-redux";
// // // // import { useHistory } from "react-router-dom";
// // // // import { useSnackbar } from "react-simple-snackbar";
// // // // import { makeStyles } from "@material-ui/core/styles";
// // // // import {
// // // //   Container,
// // // //   Typography,
// // // //   Button,
// // // //   Table,
// // // //   TableBody,
// // // //   TableCell,
// // // //   TableHead,
// // // //   TableRow,
// // // //   Paper,
// // // //   TableContainer,
// // // //   Box,
// // // //   TextField,
// // // //   Dialog,
// // // //   DialogTitle,
// // // //   DialogContent,
// // // //   DialogActions,
// // // // } from "@material-ui/core";
// // // // import ArrowBackIcon from "@material-ui/icons/ArrowBack";
// // // // import EditIcon from "@material-ui/icons/Edit";
// // // // import DeleteIcon from "@material-ui/icons/Delete";
// // // // import {
// // // //   deleteFuturePrice,
// // // //   fetchFuturePriceList,
// // // //   updateFuturePrice,
// // // // } from "../../actions/itemActions";

// // // // const useStyles = makeStyles((theme) => ({
// // // //   container: {
// // // //     padding: theme.spacing(3),
// // // //     maxWidth: 1200,
// // // //   },
// // // //   header: {
// // // //     display: "flex",
// // // //     alignItems: "center",
// // // //     justifyContent: "space-between",
// // // //     marginBottom: theme.spacing(3),
// // // //   },
// // // //   tableContainer: {
// // // //     marginTop: theme.spacing(2),
// // // //     maxHeight: "60vh",
// // // //     borderRadius: theme.shape.borderRadius,
// // // //     boxShadow: theme.shadows[2],
// // // //   },
// // // //   backButton: {
// // // //     borderRadius: 20,
// // // //   },
// // // //   button: {
// // // //     margin: theme.spacing(1),
// // // //     borderRadius: 20,
// // // //     padding: theme.spacing(1, 3),
// // // //     textTransform: "none",
// // // //   },
// // // //   textField: {
// // // //     "& .MuiOutlinedInput-root": {
// // // //       "& fieldset": {
// // // //         borderColor: "#ddd",
// // // //       },
// // // //       "&:hover fieldset": {
// // // //         borderColor: "#ef7f1a",
// // // //       },
// // // //       "&.Mui-focused fieldset": {
// // // //         borderColor: "#ef7f1a",
// // // //       },
// // // //     },
// // // //   },
// // // //   disabledRow: {
// // // //     backgroundColor: theme.palette.grey[200],
// // // //     opacity: 0.6,
// // // //   },
// // // //   dialogTitle: {
// // // //     backgroundColor: "#ef7f1a",
// // // //     color: "white",
// // // //   },
// // // //   dialogContent: {
// // // //     padding: theme.spacing(2),
// // // //   },
// // // // }));

// // // // const FuturePriceListView = () => {
// // // //   const classes = useStyles();
// // // //   const dispatch = useDispatch();
// // // //   const history = useHistory();
// // // //   const [openSnackbar] = useSnackbar();
// // // //   const { items, futurePrices, isLoading } = useSelector(
// // // //     (state) => state.items
// // // //   );

// // // //   // State for edit dialog
// // // //   const [editDialogOpen, setEditDialogOpen] = useState(false);
// // // //   const [editPrice, setEditPrice] = useState({
// // // //     _id: "",
// // // //     itemId: "",
// // // //     salePrice: "",
// // // //     effectiveDate: "",
// // // //   });
// // // //   const [editErrors, setEditErrors] = useState({
// // // //     salePrice: "",
// // // //     effectiveDate: "",
// // // //   });

// // // //   useEffect(() => {
// // // //     dispatch(fetchFuturePriceList());
// // // //   }, [dispatch]);

// // // //   const handleEditOpen = (price) => {
// // // //     setEditPrice({
// // // //       _id: price._id,
// // // //       itemId: price.itemId,
// // // //       salePrice: price.salePrice.toString(),
// // // //       effectiveDate: new Date(price.effectiveDate).toISOString().slice(0, 16), // Format for datetime-local
// // // //     });
// // // //     setEditErrors({ salePrice: "", effectiveDate: "" });
// // // //     setEditDialogOpen(true);
// // // //   };

// // // //   const handleEditClose = () => {
// // // //     setEditDialogOpen(false);
// // // //     setEditPrice({ _id: "", itemId: "", salePrice: "", effectiveDate: "" });
// // // //   };

// // // //   const validateEditForm = () => {
// // // //     let isValid = true;
// // // //     const errors = { salePrice: "", effectiveDate: "" };

// // // //     if (!editPrice.salePrice || isNaN(Number(editPrice.salePrice))) {
// // // //       errors.salePrice = "Price must be a valid number";
// // // //       isValid = false;
// // // //     }
// // // //     if (editPrice.salePrice && Number(editPrice.salePrice) < 0) {
// // // //       errors.salePrice = "Price cannot be negative";
// // // //       isValid = false;
// // // //     }
// // // //     if (!editPrice.effectiveDate) {
// // // //       errors.effectiveDate = "Please select a date and time";
// // // //       isValid = false;
// // // //     } else {
// // // //       const selectedDate = new Date(editPrice.effectiveDate);
// // // //       const now = new Date();
// // // //       if (isNaN(selectedDate.getTime()) || selectedDate <= now) {
// // // //         errors.effectiveDate = "Date and time must be in the future";
// // // //         isValid = false;
// // // //       }
// // // //     }

// // // //     setEditErrors(errors);
// // // //     return isValid;
// // // //   };

// // // //   const handleEditSubmit = async () => {
// // // //     if (!validateEditForm()) {
// // // //       openSnackbar("Please correct the errors before submitting");
// // // //       return;
// // // //     }

// // // //     try {
// // // //       await dispatch(
// // // //         updateFuturePrice(
// // // //           editPrice._id,
// // // //           {
// // // //             itemId: editPrice.itemId,
// // // //             salePrice: Number(editPrice.salePrice),
// // // //             effectiveDate: new Date(editPrice.effectiveDate).toISOString(),
// // // //           },
// // // //           openSnackbar
// // // //         )
// // // //       );
// // // //       handleEditClose();
// // // //     } catch (error) {
// // // //       openSnackbar("Failed to update future price");
// // // //     }
// // // //   };

// // // //   const handleDelete = async (id) => {
// // // //     if (
// // // //       window.confirm("Are you sure you want to delete this scheduled price?")
// // // //     ) {
// // // //       try {
// // // //         await dispatch(deleteFuturePrice(id, openSnackbar));
// // // //       } catch (error) {
// // // //         openSnackbar("Failed to delete future price");
// // // //       }
// // // //     }
// // // //   };

// // // //   const handleBack = () => {
// // // //     history.push("/ItemsList");
// // // //   };

// // // //   return (
// // // //     <Container className={classes.container}>
// // // //       <Box className={classes.header}>
// // // //         <Button
// // // //           variant="outlined"
// // // //           color="primary"
// // // //           startIcon={<ArrowBackIcon />}
// // // //           onClick={handleBack}
// // // //           className={classes.backButton}
// // // //         >
// // // //           Back to ItemList
// // // //         </Button>
// // // //         <Typography variant="h4">Future Price List</Typography>
// // // //         <div style={{ width: 100 }} />
// // // //       </Box>

// // // //       {isLoading ? (
// // // //         <Typography variant="h6" align="center">
// // // //           Loading...
// // // //         </Typography>
// // // //       ) : futurePrices.length === 0 ? (
// // // //         <Typography variant="h6" color="textSecondary" align="center">
// // // //           No future prices scheduled.
// // // //         </Typography>
// // // //       ) : (
// // // //         <TableContainer component={Paper} className={classes.tableContainer}>
// // // //           <Table stickyHeader size="small">
// // // //             <TableHead>
// // // //               <TableRow>
// // // //                 <TableCell>S.No</TableCell>
// // // //                 <TableCell>Item Name</TableCell>
// // // //                 <TableCell>Sale Price</TableCell>
// // // //                 <TableCell>Effective Date and Time</TableCell>
// // // //                 <TableCell>Created At</TableCell>
// // // //                 <TableCell>Status</TableCell>
// // // //                 <TableCell>Actions</TableCell>
// // // //               </TableRow>
// // // //             </TableHead>
// // // //             <TableBody>
// // // //               {futurePrices.map((price, index) => {
// // // //                 const item = items.find((i) => i._id === price.itemId);
// // // //                 const isApplied =
// // // //                   price.isApplied ||
// // // //                   new Date(price.effectiveDate) <= new Date();
// // // //                 return (
// // // //                   <TableRow
// // // //                     key={price._id}
// // // //                     className={isApplied ? classes.disabledRow : ""}
// // // //                   >
// // // //                     <TableCell>{index + 1}</TableCell>
// // // //                     {/* <TableCell>{item ? item.itemName : "Unknown Item"}</TableCell> */}
// // // //                     <TableCell>
// // // //                       {(() => {
// // // //                         console.log("Item data:", item); // Debug log
// // // //                         return item ? item.itemName : "Unknown Item";
// // // //                       })()}
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       {price.salePrice
// // // //                         ? `₹${price.salePrice
// // // //                             .toString()
// // // //                             .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
// // // //                         : "N/A"}
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       {new Date(price.effectiveDate).toLocaleString()}
// // // //                     </TableCell>
// // // //                     <TableCell>
// // // //                       {new Date(price.createdAt).toLocaleDateString()}
// // // //                     </TableCell>
// // // //                     <TableCell>{isApplied ? "Applied" : "Scheduled"}</TableCell>
// // // //                     <TableCell>
// // // //                       <Button
// // // //                         variant="outlined"
// // // //                         color="primary"
// // // //                         size="small"
// // // //                         startIcon={<EditIcon />}
// // // //                         onClick={() => handleEditOpen(price)}
// // // //                         disabled={isApplied}
// // // //                         className={classes.button}
// // // //                       >
// // // //                         Edit
// // // //                       </Button>
// // // //                       <Button
// // // //                         variant="outlined"
// // // //                         color="secondary"
// // // //                         size="small"
// // // //                         startIcon={<DeleteIcon />}
// // // //                         onClick={() => handleDelete(price._id)}
// // // //                         disabled={isApplied}
// // // //                         className={classes.button}
// // // //                       >
// // // //                         Delete
// // // //                       </Button>
// // // //                     </TableCell>
// // // //                   </TableRow>
// // // //                 );
// // // //               })}
// // // //             </TableBody>
// // // //           </Table>
// // // //         </TableContainer>
// // // //       )}

// // // //       {/* Edit Dialog */}
// // // //       <Dialog open={editDialogOpen} onClose={handleEditClose}>
// // // //         <DialogTitle className={classes.dialogTitle}>
// // // //           Edit Future Price
// // // //         </DialogTitle>
// // // //         <DialogContent className={classes.dialogContent}>
// // // //           <TextField
// // // //             label="Sale Price"
// // // //             type="number"
// // // //             value={editPrice.salePrice}
// // // //             onChange={(e) =>
// // // //               setEditPrice({ ...editPrice, salePrice: e.target.value })
// // // //             }
// // // //             fullWidth
// // // //             margin="normal"
// // // //             variant="outlined"
// // // //             className={classes.textField}
// // // //             error={!!editErrors.salePrice}
// // // //             helperText={editErrors.salePrice}
// // // //           />
// // // //           <TextField
// // // //             label="Effective Date and Time"
// // // //             type="datetime-local"
// // // //             value={editPrice.effectiveDate}
// // // //             onChange={(e) =>
// // // //               setEditPrice({ ...editPrice, effectiveDate: e.target.value })
// // // //             }
// // // //             fullWidth
// // // //             margin="normal"
// // // //             InputLabelProps={{ shrink: true }}
// // // //             variant="outlined"
// // // //             className={classes.textField}
// // // //             error={!!editErrors.effectiveDate}
// // // //             helperText={editErrors.effectiveDate}
// // // //           />
// // // //         </DialogContent>
// // // //         <DialogActions>
// // // //           <Button onClick={handleEditClose} color="primary">
// // // //             Cancel
// // // //           </Button>
// // // //           <Button
// // // //             onClick={handleEditSubmit}
// // // //             color="primary"
// // // //             variant="contained"
// // // //           >
// // // //             Save
// // // //           </Button>
// // // //         </DialogActions>
// // // //       </Dialog>
// // // //     </Container>
// // // //   );
// // // // };

// // // // export default FuturePriceListView;

// // // import React, { useState, useEffect } from "react";
// // // import { useDispatch, useSelector } from "react-redux";
// // // import { useHistory } from "react-router-dom";
// // // import { useSnackbar } from "react-simple-snackbar";
// // // import { makeStyles } from "@material-ui/core/styles";
// // // import {
// // //   Container,
// // //   Typography,
// // //   Button,
// // //   Table,
// // //   TableBody,
// // //   TableCell,
// // //   TableHead,
// // //   TableRow,
// // //   Paper,
// // //   TableContainer,
// // //   Box,
// // //   TextField,
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   DialogActions,
// // // } from "@material-ui/core";
// // // import ArrowBackIcon from "@material-ui/icons/ArrowBack";
// // // import EditIcon from "@material-ui/icons/Edit";
// // // import DeleteIcon from "@material-ui/icons/Delete";
// // // import {
// // //   deleteFuturePrice,
// // //   fetchFuturePriceList,
// // //   updateFuturePrice,
// // //   getAllItems, // Added
// // // } from "../../actions/itemActions";

// // // const useStyles = makeStyles((theme) => ({
// // //   container: {
// // //     padding: theme.spacing(3),
// // //     maxWidth: 1200,
// // //   },
// // //   header: {
// // //     display: "flex",
// // //     alignItems: "center",
// // //     justifyContent: "space-between",
// // //     marginBottom: theme.spacing(3),
// // //   },
// // //   tableContainer: {
// // //     marginTop: theme.spacing(2),
// // //     maxHeight: "60vh",
// // //     borderRadius: theme.shape.borderRadius,
// // //     boxShadow: theme.shadows[2],
// // //   },
// // //   backButton: {
// // //     borderRadius: 20,
// // //   },
// // //   button: {
// // //     margin: theme.spacing(1),
// // //     borderRadius: 20,
// // //     padding: theme.spacing(1, 3),
// // //     textTransform: "none",
// // //   },
// // //   textField: {
// // //     "& .MuiOutlinedInput-root": {
// // //       "& fieldset": {
// // //         borderColor: "#ddd",
// // //       },
// // //       "&:hover fieldset": {
// // //         borderColor: "#ef7f1a",
// // //       },
// // //       "&.Mui-focused fieldset": {
// // //         borderColor: "#ef7f1a",
// // //       },
// // //     },
// // //   },
// // //   disabledRow: {
// // //     backgroundColor: theme.palette.grey[200],
// // //     opacity: 0.6,
// // //   },
// // //   dialogTitle: {
// // //     backgroundColor: "#ef7f1a",
// // //     color: "white",
// // //   },
// // //   dialogContent: {
// // //     padding: theme.spacing(2),
// // //   },
// // // }));

// // // const FuturePriceListView = () => {
// // //   const classes = useStyles();
// // //   const dispatch = useDispatch();
// // //   const history = useHistory();
// // //   const [openSnackbar] = useSnackbar();
// // //   const { items, futurePrices, isLoading } = useSelector((state) => state.items);

// // //   // State for edit dialog
// // //   const [editDialogOpen, setEditDialogOpen] = useState(false);
// // //   const [editPrice, setEditPrice] = useState({
// // //     _id: "",
// // //     itemId: "",
// // //     salePrice: "",
// // //     effectiveDate: "",
// // //   });
// // //   const [editErrors, setEditErrors] = useState({
// // //     salePrice: "",
// // //     effectiveDate: "",
// // //   });

// // //   useEffect(() => {
// // //     dispatch(getAllItems()); // Ensure items are loaded
// // //     dispatch(fetchFuturePriceList());
// // //   }, [dispatch]);

// // //   // const handleEditOpen = (price) => {
// // //   //   setEditPrice({
// // //   //     _id: price._id,
// // //   //     itemId: price.itemId,
// // //   //     salePrice: price.salePrice.toString(),
// // //   //     effectiveDate: new Date(price.effectiveDate).toISOString().slice(0, 16),
// // //   //   });
// // //   //   setEditErrors({ salePrice: "", effectiveDate: "" });
// // //   //   setEditDialogOpen(true);
// // //   // };
// // //   const handleEditOpen = (price) => {
// // //     // Convert effectiveDate to local timezone
// // //     const effectiveDate = new Date(price.effectiveDate);
// // //     const localDateTime = new Date(
// // //       effectiveDate.getTime() - effectiveDate.getTimezoneOffset() * 60000
// // //     )
// // //       .toISOString()
// // //       .slice(0, 16);
  
// // //     setEditPrice({
// // //       _id: price._id,
// // //       itemId: price.itemId,
// // //       salePrice: price.salePrice.toString(),
// // //       effectiveDate: localDateTime,
// // //     });
// // //     setEditErrors({ salePrice: "", effectiveDate: "" });
// // //     setEditDialogOpen(true);
// // //   };
// // //   const handleEditClose = () => {
// // //     setEditDialogOpen(false);
// // //     setEditPrice({ _id: "", itemId: "", salePrice: "", effectiveDate: "" });
// // //   };

// // //   const validateEditForm = () => {
// // //     let isValid = true;
// // //     const errors = { salePrice: "", effectiveDate: "" };

// // //     if (!editPrice.salePrice || isNaN(Number(editPrice.salePrice))) {
// // //       errors.salePrice = "Price must be a valid number";
// // //       isValid = false;
// // //     }
// // //     if (editPrice.salePrice && Number(editPrice.salePrice) < 0) {
// // //       errors.salePrice = "Price cannot be negative";
// // //       isValid = false;
// // //     }
// // //     if (!editPrice.effectiveDate) {
// // //       errors.effectiveDate = "Please select a date and time";
// // //       isValid = false;
// // //     } else {
// // //       const selectedDate = new Date(editPrice.effectiveDate);
// // //       const now = new Date();
// // //       if (isNaN(selectedDate.getTime()) || selectedDate <= now) {
// // //         errors.effectiveDate = "Date and time must be in the future";
// // //         isValid = false;
// // //       }
// // //     }

// // //     setEditErrors(errors);
// // //     return isValid;
// // //   };

// // //   // const handleEditSubmit = async () => {
// // //   //   if (!validateEditForm()) {
// // //   //     openSnackbar("Please correct the errors before submitting");
// // //   //     return;
// // //   //   }

// // //   //   try {
// // //   //     await dispatch(
// // //   //       updateFuturePrice(
// // //   //         editPrice._id,
// // //   //         {
// // //   //           itemId: editPrice.itemId,
// // //   //           salePrice: Number(editPrice.salePrice),
// // //   //           effectiveDate: new Date(editPrice.effectiveDate).toISOString(),
// // //   //         },
// // //   //         openSnackbar
// // //   //       )
// // //   //     );
// // //   //     handleEditClose();
// // //   //   } catch (error) {
// // //   //     openSnackbar("Failed to update future price");
// // //   //   }
// // //   // };

// // //   const handleEditSubmit = async () => {
// // //     if (!validateEditForm()) {
// // //       openSnackbar("Please correct the errors before submitting");
// // //       return;
// // //     }
  
// // //     // Prepare payload
// // //     const payload = {
// // //       itemId: editPrice.itemId,
// // //       salePrice: Number(editPrice.salePrice),
// // //       effectiveDate: new Date(editPrice.effectiveDate).toISOString(),
// // //     };
  
// // //     console.log("Updating future price with payload:", payload);
  
// // //     try {
// // //       await dispatch(updateFuturePrice(editPrice._id, payload, openSnackbar));
// // //       handleEditClose();
// // //     } catch (error) {
// // //       console.error("Error in handleEditSubmit:", error);
// // //       openSnackbar(`Failed to update future price: ${error.message}`);
// // //     }
// // //   };
// // //   const handleDelete = async (id) => {
// // //     if (window.confirm("Are you sure you want to delete this scheduled price?")) {
// // //       try {
// // //         await dispatch(deleteFuturePrice(id, openSnackbar));
// // //       } catch (error) {
// // //         openSnackbar("Failed to delete future price");
// // //       }
// // //     }
// // //   };

// // //   const handleBack = () => {
// // //     history.push("/ItemsList");
// // //   };

// // //   return (
// // //     <Container className={classes.container}>
// // //       <Box className={classes.header}>
// // //         <Button
// // //           variant="outlined"
// // //           color="primary"
// // //           startIcon={<ArrowBackIcon />}
// // //           onClick={handleBack}
// // //           className={classes.backButton}
// // //         >
// // //           Back to ItemList
// // //         </Button>
// // //         <Typography variant="h4">Future Price List</Typography>
// // //         <div style={{ width: 100 }} />
// // //       </Box>

// // //       {isLoading ? (
// // //         <Typography variant="h6" align="center">
// // //           Loading...
// // //         </Typography>
// // //       ) : futurePrices.length === 0 ? (
// // //         <Typography variant="h6" color="textSecondary" align="center">
// // //           No future prices scheduled.
// // //         </Typography>
// // //       ) : (
// // //         <TableContainer component={Paper} className={classes.tableContainer}>
// // //           <Table stickyHeader size="small">
// // //             <TableHead>
// // //               <TableRow>
// // //                 <TableCell>S.No</TableCell>
// // //                 <TableCell>Item Name</TableCell>
// // //                 <TableCell>Sale Price</TableCell>
// // //                 <TableCell>Effective Date and Time</TableCell>
// // //                 <TableCell>Created At</TableCell>
// // //                 <TableCell>Status</TableCell>
// // //                 <TableCell>Actions</TableCell>
// // //               </TableRow>
// // //             </TableHead>
// // //             <TableBody>
// // //               {futurePrices.map((price, index) => {
// // //                 const isApplied =
// // //                   price.isApplied || new Date(price.effectiveDate) <= new Date();
// // //                 return (
// // //                   <TableRow
// // //                     key={price._id}
// // //                     className={isApplied ? classes.disabledRow : ""}
// // //                   >
// // //                     <TableCell>{index + 1}</TableCell>
// // //                     <TableCell>
// // //                       {price.itemId && price.itemId.itemName
// // //                         ? price.itemId.itemName
// // //                         : "Unknown Item"}
// // //                     </TableCell>
// // //                     <TableCell>
// // //                       {price.salePrice
// // //                         ? `₹${price.salePrice
// // //                             .toString()
// // //                             .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
// // //                         : "N/A"}
// // //                     </TableCell>
// // //                     <TableCell>
// // //                       {new Date(price.effectiveDate).toLocaleString()}
// // //                     </TableCell>
// // //                     <TableCell>
// // //                       {new Date(price.createdAt).toLocaleDateString()}
// // //                     </TableCell>
// // //                     <TableCell>{isApplied ? "Applied" : "Scheduled"}</TableCell>
// // //                     <TableCell>
// // //                       <Button
// // //                         variant="outlined"
// // //                         color="primary"
// // //                         size="small"
// // //                         startIcon={<EditIcon />}
// // //                         onClick={() => handleEditOpen(price)}
// // //                         disabled={isApplied}
// // //                         className={classes.button}
// // //                       >
// // //                         Edit
// // //                       </Button>
// // //                       <Button
// // //                         variant="outlined"
// // //                         color="secondary"
// // //                         size="small"
// // //                         startIcon={<DeleteIcon />}
// // //                         onClick={() => handleDelete(price._id)}
// // //                         disabled={isApplied}
// // //                         className={classes.button}
// // //                       >
// // //                         Delete
// // //                       </Button>
// // //                     </TableCell>
// // //                   </TableRow>
// // //                 );
// // //               })}
// // //             </TableBody>
// // //           </Table>
// // //         </TableContainer>
// // //       )}

// // //       {/* Edit Dialog */}
// // //       <Dialog open={editDialogOpen} onClose={handleEditClose}>
// // //         <DialogTitle className={classes.dialogTitle}>
// // //           Edit Future Price
// // //         </DialogTitle>
// // //         <DialogContent className={classes.dialogContent}>
// // //           <TextField
// // //             label="Sale Price"
// // //             type="number"
// // //             value={editPrice.salePrice}
// // //             onChange={(e) =>
// // //               setEditPrice({ ...editPrice, salePrice: e.target.value })
// // //             }
// // //             fullWidth
// // //             margin="normal"
// // //             variant="outlined"
// // //             className={classes.textField}
// // //             error={!!editErrors.salePrice}
// // //             helperText={editErrors.salePrice}
// // //           />
// // //           <TextField
// // //             label="Effective Date and Time"
// // //             type="datetime-local"
// // //             value={editPrice.effectiveDate}
// // //             onChange={(e) =>
// // //               setEditPrice({ ...editPrice, effectiveDate: e.target.value })
// // //             }
// // //             fullWidth
// // //             margin="normal"
// // //             InputLabelProps={{ shrink: true }}
// // //             variant="outlined"
// // //             className={classes.textField}
// // //             error={!!editErrors.effectiveDate}
// // //             helperText={editErrors.effectiveDate}
// // //           />
// // //         </DialogContent>
// // //         <DialogActions>
// // //           <Button onClick={handleEditClose} color="primary">
// // //             Cancel
// // //           </Button>
// // //           <Button
// // //             onClick={handleEditSubmit}
// // //             color="primary"
// // //             variant="contained"
// // //           >
// // //             Save
// // //           </Button>
// // //         </DialogActions>
// // //       </Dialog>
// // //     </Container>
// // //   );
// // // };

// // // export default FuturePriceListView;

// // import React, { useState, useEffect } from "react";
// // import { useDispatch, useSelector } from "react-redux";
// // import { useHistory } from "react-router-dom";
// // import { useSnackbar } from "react-simple-snackbar";
// // import { makeStyles } from "@material-ui/core/styles";
// // import {
// //   Container,
// //   Typography,
// //   Button,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableHead,
// //   TableRow,
// //   Paper,
// //   TableContainer,
// //   Box,
// //   TextField,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// // } from "@material-ui/core";
// // import ArrowBackIcon from "@material-ui/icons/ArrowBack";
// // import EditIcon from "@material-ui/icons/Edit";
// // import DeleteIcon from "@material-ui/icons/Delete";
// // import {
// //   deleteFuturePrice,
// //   fetchFuturePriceList,
// //   updateFuturePrice,
// //   getAllItems,
// // } from "../../actions/itemActions";

// // const useStyles = makeStyles((theme) => ({
// //   container: {
// //     padding: theme.spacing(3),
// //     maxWidth: 1200,
// //   },
// //   header: {
// //     display: "flex",
// //     alignItems: "center",
// //     justifyContent: "space-between",
// //     marginBottom: theme.spacing(3),
// //   },
// //   tableContainer: {
// //     marginTop: theme.spacing(2),
// //     maxHeight: "60vh",
// //     borderRadius: theme.shape.borderRadius,
// //     boxShadow: theme.shadows[2],
// //   },
// //   backButton: {
// //     borderRadius: 20,
// //   },
// //   button: {
// //     margin: theme.spacing(1),
// //     borderRadius: 20,
// //     padding: theme.spacing(1, 3),
// //     textTransform: "none",
// //   },
// //   textField: {
// //     "& .MuiOutlinedInput-root": {
// //       "& fieldset": {
// //         borderColor: "#ddd",
// //       },
// //       "&:hover fieldset": {
// //         borderColor: "#ef7f1a",
// //       },
// //       "&.Mui-focused fieldset": {
// //         borderColor: "#ef7f1a",
// //       },
// //     },
// //   },
// //   disabledRow: {
// //     backgroundColor: theme.palette.grey[200],
// //     opacity: 0.6,
// //   },
// //   dialogTitle: {
// //     backgroundColor: "#ef7f1a",
// //     color: "white",
// //   },
// //   dialogContent: {
// //     padding: theme.spacing(2),
// //   },
// // }));

// // const FuturePriceListView = () => {
// //   const classes = useStyles();
// //   const dispatch = useDispatch();
// //   const history = useHistory();
// //   const [openSnackbar] = useSnackbar();
// //   const { items, futurePrices, isLoading } = useSelector((state) => state.items);

// //   // State for edit dialog
// //   const [editDialogOpen, setEditDialogOpen] = useState(false);
// //   const [editPrice, setEditPrice] = useState({
// //     _id: "",
// //     itemId: "",
// //     salePrice: "",
// //     effectiveDate: "",
// //   });
// //   const [editErrors, setEditErrors] = useState({
// //     salePrice: "",
// //     effectiveDate: "",
// //   });

// //   useEffect(() => {
// //     dispatch(getAllItems());
// //     dispatch(fetchFuturePriceList());
// //   }, [dispatch]);

// //   const handleEditOpen = (price) => {
// //     // Convert effectiveDate to local timezone
// //     const effectiveDate = new Date(price.effectiveDate);
// //     const localDateTime = new Date(
// //       effectiveDate.getTime() - effectiveDate.getTimezoneOffset() * 60000
// //     )
// //       .toISOString()
// //       .slice(0, 16);

// //     setEditPrice({
// //       _id: price._id,
// //       itemId: price.itemId,
// //       salePrice: price.salePrice.toString(),
// //       effectiveDate: localDateTime,
// //     });
// //     setEditErrors({ salePrice: "", effectiveDate: "" });
// //     setEditDialogOpen(true);
// //   };

// //   const handleEditClose = () => {
// //     setEditDialogOpen(false);
// //     setEditPrice({ _id: "", itemId: "", salePrice: "", effectiveDate: "" });
// //   };

// //   const validateEditForm = () => {
// //     let isValid = true;
// //     const errors = { salePrice: "", effectiveDate: "" };

// //     if (!editPrice.salePrice || isNaN(Number(editPrice.salePrice))) {
// //       errors.salePrice = "Price must be a valid number";
// //       isValid = false;
// //     }
// //     if (editPrice.salePrice && Number(editPrice.salePrice) < 0) {
// //       errors.salePrice = "Price cannot be negative";
// //       isValid = false;
// //     }
// //     if (!editPrice.effectiveDate) {
// //       errors.effectiveDate = "Please select a date and time";
// //       isValid = false;
// //     } else {
// //       const selectedDate = new Date(editPrice.effectiveDate);
// //       const now = new Date();
// //       if (isNaN(selectedDate.getTime()) || selectedDate <= now) {
// //         errors.effectiveDate = "Date and time must be in the future";
// //         isValid = false;
// //       }
// //     }

// //     setEditErrors(errors);
// //     return isValid;
// //   };

// //   const handleEditSubmit = async () => {
// //     if (!validateEditForm()) {
// //       openSnackbar("Please correct the errors before submitting");
// //       return;
// //     }

// //     const payload = {
// //       itemId: typeof editPrice.itemId === "object" ? editPrice.itemId._id : editPrice.itemId,
// //       salePrice: Number(editPrice.salePrice),
// //       effectiveDate: new Date(editPrice.effectiveDate).toISOString(),
// //     };

// //     console.log("Updating future price with payload:", payload);

// //     try {
// //       await dispatch(updateFuturePrice(editPrice._id, payload, openSnackbar));
// //       handleEditClose();
// //     } catch (error) {
// //       console.error("Error in handleEditSubmit:", error);
// //       openSnackbar(`Failed to update future price: ${error.message}`);
// //     }
// //   };

// //   const handleDelete = async (id) => {
// //     if (window.confirm("Are you sure you want to delete this scheduled price?")) {
// //       try {
// //         await dispatch(deleteFuturePrice(id, openSnackbar));
// //       } catch (error) {
// //         openSnackbar("Failed to delete future price");
// //       }
// //     }
// //   };

// //   const handleBack = () => {
// //     history.push("/ItemsList");
// //   };

// //   return (
// //     <Container className={classes.container}>
// //       <Box className={classes.header}>
// //         <Button
// //           variant="outlined"
// //           color="primary"
// //           startIcon={<ArrowBackIcon />}
// //           onClick={handleBack}
// //           className={classes.backButton}
// //         >
// //           Back to ItemList
// //         </Button>
// //         <Typography variant="h4">Future Price List</Typography>
// //         <div style={{ width: 100 }} />
// //       </Box>

// //       {isLoading ? (
// //         <Typography variant="h6" align="center">
// //           Loading...
// //         </Typography>
// //       ) : futurePrices.length === 0 ? (
// //         <Typography variant="h6" color="textSecondary" align="center">
// //           No future prices scheduled.
// //         </Typography>
// //       ) : (
// //         <TableContainer component={Paper} className={classes.tableContainer}>
// //           <Table stickyHeader size="small">
// //             <TableHead>
// //               <TableRow>
// //                 <TableCell>S.No</TableCell>
// //                 <TableCell>Item Name</TableCell>
// //                 <TableCell>Sale Price</TableCell>
// //                 <TableCell>Effective Date and Time</TableCell>
// //                 <TableCell>Created At</TableCell>
// //                 <TableCell>Status</TableCell>
// //                 <TableCell>Actions</TableCell>
// //               </TableRow>
// //             </TableHead>
// //             <TableBody>
// //               {futurePrices.map((price, index) => {
// //                 const isApplied =
// //                   price.isApplied || new Date(price.effectiveDate) <= new Date();
// //                 return (
// //                   <TableRow
// //                     key={price._id}
// //                     className={isApplied ? classes.disabledRow : ""}
// //                   >
// //                     <TableCell>{index + 1}</TableCell>
// //                     <TableCell>
// //                       {price.itemId && price.itemId.itemName
// //                         ? price.itemId.itemName
// //                         : "Unknown Item"}
// //                     </TableCell>
// //                     <TableCell>
// //                       {price.salePrice
// //                         ? `₹${price.salePrice
// //                             .toString()
// //                             .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
// //                         : "N/A"}
// //                     </TableCell>
// //                     <TableCell>
// //                       {new Date(price.effectiveDate).toLocaleString()}
// //                     </TableCell>
// //                     <TableCell>
// //                       {new Date(price.createdAt).toLocaleDateString()}
// //                     </TableCell>
// //                     <TableCell>{isApplied ? "Applied" : "Scheduled"}</TableCell>
// //                     <TableCell>
// //                       <Button
// //                         variant="outlined"
// //                         color="primary"
// //                         size="small"
// //                         startIcon={<EditIcon />}
// //                         onClick={() => handleEditOpen(price)}
// //                         disabled={isApplied}
// //                         className={classes.button}
// //                       >
// //                         Edit
// //                       </Button>
// //                       <Button
// //                         variant="outlined"
// //                         color="secondary"
// //                         size="small"
// //                         startIcon={<DeleteIcon />}
// //                         onClick={() => handleDelete(price._id)}
// //                         disabled={isApplied}
// //                         className={classes.button}
// //                       >
// //                         Delete
// //                       </Button>
// //                     </TableCell>
// //                   </TableRow>
// //                 );
// //               })}
// //             </TableBody>
// //           </Table>
// //         </TableContainer>
// //       )}

// //       {/* Edit Dialog */}
// //       <Dialog open={editDialogOpen} onClose={handleEditClose}>
// //         <DialogTitle className={classes.dialogTitle}>
// //           Edit Future Price
// //         </DialogTitle>
// //         <DialogContent className={classes.dialogContent}>
// //           <TextField
// //             label="Sale Price"
// //             type="number"
// //             value={editPrice.salePrice}
// //             onChange={(e) =>
// //               setEditPrice({ ...editPrice, salePrice: e.target.value })
// //             }
// //             fullWidth
// //             margin="normal"
// //             variant="outlined"
// //             className={classes.textField}
// //             error={!!editErrors.salePrice}
// //             helperText={editErrors.salePrice}
// //           />
// //           <TextField
// //             label="Effective Date and Time"
// //             type="datetime-local"
// //             value={editPrice.effectiveDate}
// //             onChange={(e) =>
// //               setEditPrice({ ...editPrice, effectiveDate: e.target.value })
// //             }
// //             fullWidth
// //             margin="normal"
// //             InputLabelProps={{ shrink: true }}
// //             variant="outlined"
// //             className={classes.textField}
// //             error={!!editErrors.effectiveDate}
// //             helperText={editErrors.effectiveDate}
// //           />
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={handleEditClose} color="primary">
// //             Cancel
// //           </Button>
// //           <Button
// //             onClick={handleEditSubmit}
// //             color="primary"
// //             variant="contained"
// //           >
// //             Save
// //           </Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Container>
// //   );
// // };

// // export default FuturePriceListView;

// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useHistory } from "react-router-dom";
// import { useSnackbar } from "react-simple-snackbar";
// import { makeStyles } from "@material-ui/core/styles";
// import {
//   Container,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   Paper,
//   TableContainer,
//   Box,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TablePagination,
// } from "@material-ui/core";
// import ArrowBackIcon from "@material-ui/icons/ArrowBack";
// import EditIcon from "@material-ui/icons/Edit";
// import DeleteIcon from "@material-ui/icons/Delete";
// import {
//   deleteFuturePrice,
//   fetchFuturePriceList,
//   updateFuturePrice,
//   getAllItems,
// } from "../../actions/itemActions";

// const useStyles = makeStyles((theme) => ({
//   container: {
//     padding: theme.spacing(3),
//     maxWidth: 1200,
//   },
//   header: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     marginBottom: theme.spacing(3),
//   },
//   tableContainer: {
//     marginTop: theme.spacing(2),
//     maxHeight: "60vh",
//     borderRadius: theme.shape.borderRadius,
//     boxShadow: theme.shadows[2],
//   },
//   backButton: {
//     borderRadius: 20,
//   },
//   button: {
//     margin: theme.spacing(1),
//     borderRadius: 20,
//     padding: theme.spacing(1, 3),
//     textTransform: "none",
//   },
//   textField: {
//     "& .MuiOutlinedInput-root": {
//       "& fieldset": {
//         borderColor: "#ddd",
//       },
//       "&:hover fieldset": {
//         borderColor: "#ef7f1a",
//       },
//       "&.Mui-focused fieldset": {
//         borderColor: "#ef7f1a",
//       },
//     },
//   },
//   disabledRow: {
//     backgroundColor: theme.palette.grey[200],
//     opacity: 0.6,
//   },
//   dialogTitle: {
//     backgroundColor: "#ef7f1a",
//     color: "white",
//   },
//   dialogContent: {
//     padding: theme.spacing(2),
//   },
//   pagination: {
//     marginTop: theme.spacing(2),
//   },
// }));

// const FuturePriceListView = () => {
//   const classes = useStyles();
//   const dispatch = useDispatch();
//   const history = useHistory();
//   const [openSnackbar] = useSnackbar();
//   const { items, futurePrices, isLoading } = useSelector((state) => state.items);

//   // State for pagination
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);

//   // State for edit dialog
//   const [editDialogOpen, setEditDialogOpen] = useState(false);
//   const [editPrice, setEditPrice] = useState({
//     _id: "",
//     itemId: "",
//     salePrice: "",
//     effectiveDate: "",
//   });
//   const [editErrors, setEditErrors] = useState({
//     salePrice: "",
//     effectiveDate: "",
//   });

//   useEffect(() => {
//     dispatch(getAllItems());
//     dispatch(fetchFuturePriceList());
//   }, [dispatch]);

//   // Sort futurePrices by createdAt in descending order (newest first)
//   const sortedFuturePrices = [...futurePrices].sort(
//     (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
//   );

//   // Pagination handlers
//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleEditOpen = (price) => {
//     const effectiveDate = new Date(price.effectiveDate);
//     const localDateTime = new Date(
//       effectiveDate.getTime() - effectiveDate.getTimezoneOffset() * 60000
//     )
//       .toISOString()
//       .slice(0, 16);

//     setEditPrice({
//       _id: price._id,
//       itemId: price.itemId,
//       salePrice: price.salePrice.toString(),
//       effectiveDate: localDateTime,
//     });
//     setEditErrors({ salePrice: "", effectiveDate: "" });
//     setEditDialogOpen(true);
//   };

//   const handleEditClose = () => {
//     setEditDialogOpen(false);
//     setEditPrice({ _id: "", itemId: "", salePrice: "", effectiveDate: "" });
//   };

//   const validateEditForm = () => {
//     let isValid = true;
//     const errors = { salePrice: "", effectiveDate: "" };

//     if (!editPrice.salePrice || isNaN(Number(editPrice.salePrice))) {
//       errors.salePrice = "Price must be a valid number";
//       isValid = false;
//     }
//     if (editPrice.salePrice && Number(editPrice.salePrice) < 0) {
//       errors.salePrice = "Price cannot be negative";
//       isValid = false;
//     }
//     if (!editPrice.effectiveDate) {
//       errors.effectiveDate = "Please select a date and time";
//       isValid = false;
//     } else {
//       const selectedDate = new Date(editPrice.effectiveDate);
//       const now = new Date();
//       if (isNaN(selectedDate.getTime()) || selectedDate <= now) {
//         errors.effectiveDate = "Date and time must be in the future";
//         isValid = false;
//       }
//     }

//     setEditErrors(errors);
//     return isValid;
//   };

//   const handleEditSubmit = async () => {
//     if (!validateEditForm()) {
//       openSnackbar("Please correct the errors before submitting");
//       return;
//     }

//     const payload = {
//       itemId: typeof editPrice.itemId === "object" ? editPrice.itemId._id : editPrice.itemId,
//       salePrice: Number(editPrice.salePrice),
//       effectiveDate: new Date(editPrice.effectiveDate).toISOString(),
//     };

//     try {
//       await dispatch(updateFuturePrice(editPrice._id, payload, openSnackbar));
//       handleEditClose();
//     } catch (error) {
//       console.error("Error in handleEditSubmit:", error);
//       openSnackbar(`Failed to update future price: ${error.message}`);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this scheduled price?")) {
//       try {
//         await dispatch(deleteFuturePrice(id, openSnackbar));
//       } catch (error) {
//         openSnackbar("Failed to delete future price");
//       }
//     }
//   };

//   const handleBack = () => {
//     history.push("/ItemsList");
//   };

//   // Calculate the rows to display based on pagination
//   const paginatedPrices = sortedFuturePrices.slice(
//     page * rowsPerPage,
//     page * rowsPerPage + rowsPerPage
//   );

//   return (
//     <Container className={classes.container}>
//       <Box className={classes.header}>
//         <Button
//           variant="outlined"
//           color="primary"
//           startIcon={<ArrowBackIcon />}
//           onClick={handleBack}
//           className={classes.backButton}
//         >
//           Back to ItemList
//         </Button>
//         <Typography variant="h4">Future Price List</Typography>
//         <div style={{ width: 100 }} />
//       </Box>

//       {isLoading ? (
//         <Typography variant="h6" align="center">
//           Loading...
//         </Typography>
//       ) : sortedFuturePrices.length === 0 ? (
//         <Typography variant="h6" color="textSecondary" align="center">
//           No future prices scheduled.
//         </Typography>
//       ) : (
//         <>
//           <TableContainer component={Paper} className={classes.tableContainer}>
//             <Table stickyHeader size="small">
//               <TableHead>
//                 <TableRow>
//                   <TableCell>S.No</TableCell>
//                   <TableCell>Item Name</TableCell>
//                   <TableCell>Sale Price</TableCell>
//                   <TableCell>Effective Date and Time</TableCell>
//                   <TableCell>Created At</TableCell>
//                   <TableCell>Status</TableCell>
//                   <TableCell>Actions</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {paginatedPrices.map((price, index) => {
//                   const isApplied =
//                     price.isApplied || new Date(price.effectiveDate) <= new Date();
//                   return (
//                     <TableRow
//                       key={price._id}
//                       className={isApplied ? classes.disabledRow : ""}
//                     >
//                       <TableCell>{page * rowsPerPage + index + 1}</TableCell>
//                       <TableCell>
//                         {price.itemId && price.itemId.itemName
//                           ? price.itemId.itemName
//                           : "Unknown Item"}
//                       </TableCell>
//                       <TableCell>
//                         {price.salePrice
//                           ? `₹${price.salePrice
//                               .toString()
//                               .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
//                           : "N/A"}
//                       </TableCell>
//                       <TableCell>
//                         {new Date(price.effectiveDate).toLocaleString()}
//                       </TableCell>
//                       <TableCell>
//                         {new Date(price.createdAt).toLocaleDateString()}
//                       </TableCell>
//                       <TableCell>{isApplied ? "Applied" : "Scheduled"}</TableCell>
//                       <TableCell>
//                         <Button
//                           variant="outlined"
//                           color="primary"
//                           size="small"
//                           startIcon={<EditIcon />}
//                           onClick={() => handleEditOpen(price)}
//                           disabled={isApplied}
//                           className={classes.button}
//                         >
//                           Edit
//                         </Button>
//                         <Button
//                           variant="outlined"
//                           color="secondary"
//                           size="small"
//                           startIcon={<DeleteIcon />}
//                           onClick={() => handleDelete(price._id)}
//                           disabled={isApplied}
//                           className={classes.button}
//                         >
//                           Delete
//                         </Button>
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })}
//               </TableBody>
//             </Table>
//           </TableContainer>
//           <TablePagination
//             className={classes.pagination}
//             rowsPerPageOptions={[7, 10, 25, 50]}
//             component="div"
//             count={sortedFuturePrices.length}
//             rowsPerPage={rowsPerPage}
//             page={page}
//             onPageChange={handleChangePage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//           />
//         </>
//       )}

//       {/* Edit Dialog */}
//       <Dialog open={editDialogOpen} onClose={handleEditClose}>
//         <DialogTitle className={classes.dialogTitle}>
//           Edit Future Price
//         </DialogTitle>
//         <DialogContent className={classes.dialogContent}>
//           <TextField
//             label="Sale Price"
//             type="number"
//             value={editPrice.salePrice}
//             onChange={(e) =>
//               setEditPrice({ ...editPrice, salePrice: e.target.value })
//             }
//             fullWidth
//             margin="normal"
//             variant="outlined"
//             className={classes.textField}
//             error={!!editErrors.salePrice}
//             helperText={editErrors.salePrice}
//           />
//           <TextField
//             label="Effective Date and Time"
//             type="datetime-local"
//             value={editPrice.effectiveDate}
//             onChange={(e) =>
//               setEditPrice({ ...editPrice, effectiveDate: e.target.value })
//             }
//             fullWidth
//             margin="normal"
//             InputLabelProps={{ shrink: true }}
//             variant="outlined"
//             className={classes.textField}
//             error={!!editErrors.effectiveDate}
//             helperText={editErrors.effectiveDate}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleEditClose} color="primary">
//             Cancel
//           </Button>
//           <Button
//             onClick={handleEditSubmit}
//             color="primary"
//             variant="contained"
//           >
//             Save
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Container>
//   );
// };

// export default FuturePriceListView;

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "react-simple-snackbar";
import { makeStyles } from "@material-ui/core/styles";
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
  Tooltip,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import {
  deleteFuturePrice,
  fetchFuturePriceList,
  updateFuturePrice,
  getAllItems,
} from "../../actions/itemActions";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    maxWidth: 1200,
    margin: "auto",
    marginTop: theme.spacing(2),
    background: "#f5f5f5",
    borderRadius: 8,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    background: "#ffffff",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  title: {
    fontWeight: 500,
    fontSize: "1.5rem",
    color: "#333333",
  },
  tableContainer: {
    background: "#ffffff",
    borderRadius: 8,
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  tableHead: {
    background: "#e0e0e0",
    "& th": {
      fontWeight: 600,
      color: "#333333",
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  tableRow: {
    "&:nth-child(even)": {
      backgroundColor: "#fafafa",
    },
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },
  disabledRow: {
    opacity: 0.6,
    backgroundColor: "#eeeeee",
  },
  tableCell: {
    padding: theme.spacing(1.5),
    fontSize: "0.9rem",
    color: "#333333",
  },
  backButton: {
    borderRadius: 4,
    padding: theme.spacing(1, 2),
    background: "#ffffff",
    border: "1px solid #f7851bcb",
    fontWeight: 500,
    "&:hover": {
      background: "#f7851bcb",
      color: "#ffffff",
    },
  },
  actionButton: {
    margin: theme.spacing(0, 0.5),
  },
  statusBadge: {
    padding: theme.spacing(0.5, 1),
    borderRadius: 4,
    fontSize: "0.8rem",
    fontWeight: 500,
    display: "inline-block",
  },
  statusScheduled: {
    backgroundColor: "#bbdefb",
    color: "#1976d2",
  },
  statusApplied: {
    backgroundColor: "#c8e6c9",
    color: "#388e3c",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 4,
      "& fieldset": {
        borderColor: "#cccccc",
      },
      "&:hover fieldset": {
        borderColor: "#1976d2",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1976d2",
      },
    },
    "& .MuiInputLabel-outlined": {
      color: "#666666",
    },
  },
  dialog: {
    borderRadius: 8,
  },
  dialogTitle: {
    background: "#f7851bcb",
    color: "#ffffff",
    padding: theme.spacing(2),
    "& h2": {
      fontWeight: 500,
      fontSize: "1.25rem",
    },
  },
  dialogContent: {
    padding: theme.spacing(2),
    background: "#ffffff",
  },
  saveButton: {
    borderRadius: 4,
    background: "#f7851bcb",
    color: "#ffffff",
    padding: theme.spacing(1, 2),
    "&:hover": {
      background: "#f7851bcb",
    },
  },
  cancelButton: {
    borderRadius: 4,
    color: "#f7851bcb",
    padding: theme.spacing(1, 2),
  },
  pagination: {
    marginTop: theme.spacing(2),
    background: "#ffffff",
    borderRadius: 4,
    "& .MuiTablePagination-selectRoot": {
      border: "1px solid #cccccc",
      borderRadius: 4,
    },
    "& .MuiTablePagination-select": {
      fontSize: "0.9rem",
    },
    "& .MuiIconButton-root": {
      color: "#1976d2",
      "&:hover": {
        background: "#e3f2fd",
      },
    },
  },
  emptyState: {
    padding: theme.spacing(3),
    textAlign: "center",
    color: "#666666",
    background: "#ffffff",
    borderRadius: 8,
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
  },
}));

const FuturePriceListView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [openSnackbar] = useSnackbar();
  const { items, futurePrices, isLoading } = useSelector((state) => state.items);

  // State for pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(7);

  // State for edit dialog
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editPrice, setEditPrice] = useState({
    _id: "",
    itemId: "",
    salePrice: "",
    effectiveDate: "",
  });
  const [editErrors, setEditErrors] = useState({
    salePrice: "",
    effectiveDate: "",
  });

  useEffect(() => {
    dispatch(getAllItems());
    dispatch(fetchFuturePriceList());
  }, [dispatch]);

  // Sort futurePrices by createdAt in descending order (newest first)
  const sortedFuturePrices = [...futurePrices].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEditOpen = (price) => {
    const effectiveDate = new Date(price.effectiveDate);
    const localDateTime = new Date(
      effectiveDate.getTime() - effectiveDate.getTimezoneOffset() * 60000
    )
      .toISOString()
      .slice(0, 16);

    setEditPrice({
      _id: price._id,
      itemId: price.itemId,
      salePrice: price.salePrice.toString(),
      effectiveDate: localDateTime,
    });
    setEditErrors({ salePrice: "", effectiveDate: "" });
    setEditDialogOpen(true);
  };

  const handleEditClose = () => {
    setEditDialogOpen(false);
    setEditPrice({ _id: "", itemId: "", salePrice: "", effectiveDate: "" });
  };

  const validateEditForm = () => {
    let isValid = true;
    const errors = { salePrice: "", effectiveDate: "" };

    if (!editPrice.salePrice || isNaN(Number(editPrice.salePrice))) {
      errors.salePrice = "Price must be a valid number";
      isValid = false;
    }
    if (editPrice.salePrice && Number(editPrice.salePrice) < 0) {
      errors.salePrice = "Price cannot be negative";
      isValid = false;
    }
    if (!editPrice.effectiveDate) {
      errors.effectiveDate = "Please select a date and time";
      isValid = false;
    } else {
      const selectedDate = new Date(editPrice.effectiveDate);
      const now = new Date();
      if (isNaN(selectedDate.getTime()) || selectedDate <= now) {
        errors.effectiveDate = "Date and time must be in the future";
        isValid = false;
      }
    }

    setEditErrors(errors);
    return isValid;
  };

  const handleEditSubmit = async () => {
    if (!validateEditForm()) {
      openSnackbar("Please correct the errors before submitting");
      return;
    }

    const payload = {
      itemId: typeof editPrice.itemId === "object" ? editPrice.itemId._id : editPrice.itemId,
      salePrice: Number(editPrice.salePrice),
      effectiveDate: new Date(editPrice.effectiveDate).toISOString(),
    };

    try {
      await dispatch(updateFuturePrice(editPrice._id, payload, openSnackbar));
      handleEditClose();
      openSnackbar("Future price updated successfully");
    } catch (error) {
      console.error("Error in handleEditSubmit:", error);
      openSnackbar(`Failed to update future price: ${error.message}`);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this scheduled price?")) {
      try {
        await dispatch(deleteFuturePrice(id, openSnackbar));
        openSnackbar("Future price deleted successfully");
      } catch (error) {
        openSnackbar("Failed to delete future price");
      }
    }
  };

  const handleBack = () => {
    history.push("/ItemsList");
  };

  // Calculate the rows to display based on pagination
  const paginatedPrices = sortedFuturePrices.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Container className={classes.container}>
      <Box className={classes.header}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          className={classes.backButton}
        >
          Back to ItemList
       </Button>
        <Typography className={classes.title}>Future Prices</Typography>
        <div style={{ width: 100 }} />
      </Box>

      {isLoading ? (
        <Typography variant="subtitle1" className={classes.emptyState}>
          Loading...
        </Typography>
      ) : sortedFuturePrices.length === 0 ? (
        <Typography variant="subtitle1" className={classes.emptyState}>
          No future prices scheduled.
        </Typography>
      ) : (
        <>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table stickyHeader>
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell className={classes.tableCell}>#</TableCell>
                  <TableCell className={classes.tableCell}>Item</TableCell>
                  <TableCell className={classes.tableCell}>Price</TableCell>
                  <TableCell className={classes.tableCell}>Effective</TableCell>
                  <TableCell className={classes.tableCell}>Created</TableCell>
                  <TableCell className={classes.tableCell}>Status</TableCell>
                  <TableCell className={classes.tableCell}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedPrices.map((price, index) => {
                  const isApplied =
                    price.isApplied || new Date(price.effectiveDate) <= new Date();
                  return (
                    <TableRow
                      key={price._id}
                      className={`${classes.tableRow} ${
                        isApplied ? classes.disabledRow : ""
                      }`}
                    >
                      <TableCell className={classes.tableCell}>
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {price.itemId && price.itemId.itemName
                          ? price.itemId.itemName
                          : "Unknown Item"}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {price.salePrice
                          ? `₹${price.salePrice
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                          : "N/A"}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {new Date(price.effectiveDate).toLocaleString()}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {new Date(price.createdAt).toLocaleDateString()}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <span
                          className={`${classes.statusBadge} ${
                            isApplied
                              ? classes.statusApplied
                              : classes.statusScheduled
                          }`}
                        >
                          {isApplied ? "Applied" : "Scheduled"}
                        </span>
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <Tooltip title="Edit">
                          <IconButton
                            color="primary"
                            size="small"
                            onClick={() => handleEditOpen(price)}
                            disabled={isApplied}
                            className={classes.actionButton}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton
                            color="secondary"
                            size="small"
                            onClick={() => handleDelete(price._id)}
                            disabled={isApplied}
                            className={classes.actionButton}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            className={classes.pagination}
            rowsPerPageOptions={[7, 10, 25, 50]}
            component="div"
            count={sortedFuturePrices.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}

      <Dialog
        open={editDialogOpen}
        onClose={handleEditClose}
        classes={{ paper: classes.dialog }}
      >
        <DialogTitle className={classes.dialogTitle}>Edit Price</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <TextField
            label="Sale Price"
            type="number"
            value={editPrice.salePrice}
            onChange={(e) =>
              setEditPrice({ ...editPrice, salePrice: e.target.value })
            }
            fullWidth
            margin="normal"
            variant="outlined"
            className={classes.textField}
            error={!!editErrors.salePrice}
            helperText={editErrors.salePrice}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">₹</InputAdornment>
              ),
            }}
          />
          <TextField
            label="Effective Date & Time"
            type="datetime-local"
            value={editPrice.effectiveDate}
            onChange={(e) =>
              setEditPrice({ ...editPrice, effectiveDate: e.target.value })
            }
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            className={classes.textField}
            error={!!editErrors.effectiveDate}
            helperText={editErrors.effectiveDate}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleEditClose}
            color="primary"
            className={classes.cancelButton}
          >
            Cancel
          </Button>
          <Button
            onClick={handleEditSubmit}
            color="primary"
            variant="contained"
            className={classes.saveButton}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default FuturePriceListView;